import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3,
    _t4,
    _t5;

import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import { H4 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import BestValueBadge from '../common/BestValueBadge';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons'; // @ts-expect-error svg import

import BLOB from 'bender-url!pricing-pages-ui/img/splash-page/suite-card-top-right-blob.svg';
import { BATTLESHIP } from 'HubStyleTokens/colors';
import { useAppSelector } from '../../reducers';
import { STARTER_SUITE_CARD } from '../../constants/tracking/Locations';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { CrmSuitePrice } from '../merch-card/price-display/CrmSuitePrice';
import { STARTER } from 'self-service-api/constants/ProductLevels';
import { useValidatedCrmSuiteQueryParamTerm } from '../../utils/urls/queryParamUtils';
import { hasPricingAndPurchasingSucceededSelector } from '../../selectors/LoadingStateSelectors';
import SuiteTermSelectorContainer from '../merch-card/SuiteTermSelectorContainer';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { ProductLineIcon, IconImage } from '../splash-page/SplashPageSharedComponents';
import Small from 'UIComponents/elements/Small';
import SuiteTileCTAsContainer from '../merch-card/SuiteTileCTAsContainer';
import { useIsMobile } from '../../context/IsMobileContext';
import { NEW_CUSTOMER_OFFER } from '../../constants/pricing/DiscountedKeys';
const StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__StyledCardWrapper",
  componentId: "sc-1weordf-0"
})(["display:grid;grid-template-columns:2fr 1fr;grid-template-areas:'header cta' 'content cta' 'content cta' 'disclaimer disclaimer';width:100%;padding:32px 24px;border:1px solid ", ";min-height:150px;text-align:left;margin:auto;position:relative;overflow:hidden;", ";", ";"], BATTLESHIP, breakpoint.tablet(_t || (_t = _`
    min-width: 0;
    &&& {
      margin: 0 auto;
    }

    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "content"
      "cta"
      "disclaimer";
  `)), breakpoint.tabletPortrait(_t2 || (_t2 = _`
    width: 94%;
  `)));
const StyledBlob = styled(UIImage).withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__StyledBlob",
  componentId: "sc-1weordf-1"
})(["position:absolute;top:-1px;right:-1px;"]);
const StyledBestValueBadge = styled(BestValueBadge).withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__StyledBestValueBadge",
  componentId: "sc-1weordf-2"
})(["position:absolute;z-index:1;top:12px;right:12px;"]);
const CardHeader = styled.div.withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__CardHeader",
  componentId: "sc-1weordf-3"
})(["grid-area:header;z-index:2;"]);
const ContentContainer = styled.div.withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__ContentContainer",
  componentId: "sc-1weordf-4"
})(["grid-area:content;display:flex;flex-direction:column;justify-content:space-between;", ""], breakpoint.phoneLarge(_t3 || (_t3 = _`
    margin-top: 32px;
  `)));
const CTAsContainer = styled.div.withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__CTAsContainer",
  componentId: "sc-1weordf-5"
})(["grid-area:cta;justify-self:center;display:flex;flex-direction:column;justify-content:center;align-items:stretch;height:100%;max-width:350px;width:100%;z-index:2;button,a{width:100%;line-height:25px;}div:first-child{margin-top:0 !important;}", " ", ""], breakpoint.tablet(_t4 || (_t4 = _`
    justify-content: flex-start;
    margin-top: 32px;
  `)), breakpoint.phoneLarge(_t5 || (_t5 = _`
    max-width: 100%;
    margin-top: 16px;
  `)));
const DisclaimerContainer = styled(Small).withConfig({
  displayName: "StarterCrmSuiteCtaCardGWP__DisclaimerContainer",
  componentId: "sc-1weordf-6"
})(["grid-area:disclaimer;margin-top:16px;"]);

const StarterCrmSuiteCtaCardGWP = ({
  containerStyle,
  screen = 'splash'
}) => {
  const {
    queryParamTerm,
    setQueryParamTerm
  } = useValidatedCrmSuiteQueryParamTerm({
    productLevel: STARTER
  });
  const hasPricingAndPurchasingSucceeded = useAppSelector(hasPricingAndPurchasingSucceededSelector);
  const isMobile = useIsMobile();
  const productLineChecklist = AllProductLines.map(key => {
    return /*#__PURE__*/_jsxs(ProductLineIcon, {
      className: isMobile ? '' : 'm-y-3',
      children: [/*#__PURE__*/_jsx(IconImage, {
        className: "display-inline m-right-3",
        src: ProductLinePageIcons[key]
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: `splash-page.bundles.starterCrmSuiteCard.suiteIncludes.${key}`
      })]
    }, key);
  });
  return /*#__PURE__*/_jsxs(StyledCardWrapper, {
    style: containerStyle,
    className: "m-top-5",
    children: [/*#__PURE__*/_jsx(StyledBlob, {
      src: BLOB
    }), /*#__PURE__*/_jsx(StyledBestValueBadge, {
      message: "newCustomerOffer"
    }), /*#__PURE__*/_jsx(CardHeader, {
      children: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "splash-page.bundles.STARTER.title"
        })
      })
    }), /*#__PURE__*/_jsx(ContentContainer, {
      children: productLineChecklist
    }), /*#__PURE__*/_jsxs(CTAsContainer, {
      children: [/*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [16, 23, 16],
        widths: [60, 70, 130],
        className: "flex-column align-end",
        Content: CrmSuitePrice,
        contentProps: {
          productLevel: STARTER,
          termOverride: queryParamTerm,
          useDiscountedKey: NEW_CUSTOMER_OFFER
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "m-y-3",
        children: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
          isLoading: !hasPricingAndPurchasingSucceeded,
          heights: [41],
          Content: SuiteTermSelectorContainer,
          contentProps: {
            productLevel: STARTER,
            onChange: newTerm => {
              setQueryParamTerm(newTerm);
            },
            queryParamTerm,
            trackingSource: STARTER_SUITE_CARD
          }
        })
      }), /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
        isLoading: !hasPricingAndPurchasingSucceeded,
        heights: [47],
        children: /*#__PURE__*/_jsx(SuiteTileCTAsContainer, {
          productLevel: STARTER,
          trackingSource: STARTER_SUITE_CARD,
          sourceId: `pricing-${screen}-page-starter-suite-card`,
          hubsSignupProductOverride: "suitestarter",
          isStarterGWPCard: true,
          ctaStyles: {
            marginTop: '4px'
          }
        })
      })]
    }), /*#__PURE__*/_jsx(DisclaimerContainer, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.promotions.starterGWPDisclaimer"
      })
    })]
  });
};

export default StarterCrmSuiteCtaCardGWP;